import { withPromotionListProps } from 'viewModel/content/promotionList/withPromotionListProps';
import PromotionList from 'components/Content/PromotionList/PromotionList';

export default withPromotionListProps(PromotionList);
